import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";

export const getCustomers = () => {
  return queryOptions({
    queryKey: ["customers"],
    queryFn: async () => {
      return await handleClientMethod(client.GET("/api/customers"));
    },
  });
};
